import { createActions, handleActions } from 'redux-actions'

// helpers
import { loadingError, startLoading, startSubmitting } from './_helpers'

export const CREATE_PURCHASE_REQUEST = 'purchaseRequests/CREATE_PURCHASE_REQUEST'
export const CREATE_PURCHASE_REQUEST_FAILURE = 'purchaseRequests/CREATE_PURCHASE_REQUEST_FAILURE'
export const CREATE_PURCHASE_REQUEST_SUCCESS = 'purchaseRequests/CREATE_PURCHASE_REQUEST_SUCCESS'

export const DELETE_PURCHASE_REQUEST = 'purchaseRequests/DELETE_PURCHASE_REQUEST'
export const DELETE_PURCHASE_REQUEST_FAILURE = 'purchaseRequests/DELETE_PURCHASE_REQUEST_FAILURE'
export const DELETE_PURCHASE_REQUEST_SUCCESS = 'purchaseRequests/DELETE_PURCHASE_REQUEST_SUCCESS'

export const FETCH_PURCHASE_REQUEST = 'purchaseRequests/FETCH_PURCHASE_REQUEST'
export const FETCH_PURCHASE_REQUEST_FAILURE = 'purchaseRequests/FETCH_PURCHASE_REQUEST_FAILURE'
export const FETCH_PURCHASE_REQUEST_SUCCESS = 'purchaseRequests/FETCH_PURCHASE_REQUEST_SUCCESS'

export const FETCH_PURCHASE_REQUESTS = 'purchaseRequests/FETCH_PURCHASE_REQUESTS'
export const FETCH_PURCHASE_REQUESTS_FAILURE = 'purchaseRequests/FETCH_PURCHASE_REQUESTS_FAILURE'
export const FETCH_PURCHASE_REQUESTS_SUCCESS = 'purchaseRequests/FETCH_PURCHASE_REQUESTS_SUCCESS'

export const INITIATE_PURCHASE_REQUEST_PAYMENT =
  'purchaseRequests/INITIATE_PURCHASE_REQUEST_PAYMENT'
export const INITIATE_PURCHASE_REQUEST_PAYMENT_FAILURE =
  'purchaseRequests/INITIATE_PURCHASE_REQUEST_PAYMENT_FAILURE'
export const INITIATE_PURCHASE_REQUEST_PAYMENT_SUCCESS =
  'purchaseRequests/INITIATE_PURCHASE_REQUEST_PAYMENT_SUCCESS'

export const UPDATE_PURCHASE_REQUEST = 'purchaseRequests/UPDATE_PURCHASE_REQUEST'
export const UPDATE_PURCHASE_REQUEST_FAILURE = 'purchaseRequests/UPDATE_PURCHASE_REQUEST_FAILURE'
export const UPDATE_PURCHASE_REQUEST_SUCCESS = 'purchaseRequests/UPDATE_PURCHASE_REQUEST_SUCCESS'

export const LOGOUT_SUCCESS = 'authentication/LOGOUT_SUCCESS'

export const {
  purchaseRequests: {
    createPurchaseRequest,
    createPurchaseRequestSuccess,
    createPurchaseRequestFailure,
    deletePurchaseRequest,
    deletePurchaseRequestSuccess,
    deletePurchaseRequestFailure,
    fetchPurchaseRequest,
    fetchPurchaseRequestSuccess,
    fetchPurchaseRequestFailure,
    fetchPurchaseRequests,
    fetchPurchaseRequestsSuccess,
    fetchPurchaseRequestsFailure,
    initiatePurchaseRequestPayment,
    initiatePurchaseRequestPaymentSuccess,
    initiatePurchaseRequestPaymentFailure,
    updatePurchaseRequest,
    updatePurchaseRequestSuccess,
    updatePurchaseRequestFailure
  }
} = createActions({
  [CREATE_PURCHASE_REQUEST]: undefined,
  [CREATE_PURCHASE_REQUEST_FAILURE]: undefined,
  [CREATE_PURCHASE_REQUEST_SUCCESS]: undefined,
  [DELETE_PURCHASE_REQUEST]: undefined,
  [DELETE_PURCHASE_REQUEST_FAILURE]: undefined,
  [DELETE_PURCHASE_REQUEST_SUCCESS]: undefined,
  [FETCH_PURCHASE_REQUEST]: undefined,
  [FETCH_PURCHASE_REQUEST_FAILURE]: undefined,
  [FETCH_PURCHASE_REQUEST_SUCCESS]: undefined,
  [FETCH_PURCHASE_REQUESTS]: undefined,
  [FETCH_PURCHASE_REQUESTS_FAILURE]: undefined,
  [FETCH_PURCHASE_REQUESTS_SUCCESS]: undefined,
  [INITIATE_PURCHASE_REQUEST_PAYMENT]: undefined,
  [INITIATE_PURCHASE_REQUEST_PAYMENT_FAILURE]: undefined,
  [INITIATE_PURCHASE_REQUEST_PAYMENT_SUCCESS]: undefined,
  [UPDATE_PURCHASE_REQUEST]: undefined,
  [UPDATE_PURCHASE_REQUEST_FAILURE]: undefined,
  [UPDATE_PURCHASE_REQUEST_SUCCESS]: undefined
})

const initialState = {
  isError: false,
  isLoading: false,
  isSuccess: false,
  paginatedData: {
    purchaseRequests: [],
    purchaseRequestsCount: 0,
    purchaseRequestsPageCount: 0
  },
  purchaseRequestObject: null,
  singlePurchaseRequestData: {}
}

export default handleActions(
  {
    [CREATE_PURCHASE_REQUEST]: startSubmitting,
    [CREATE_PURCHASE_REQUEST_FAILURE]: loadingError,
    [CREATE_PURCHASE_REQUEST_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_PURCHASE_REQUEST]: state => ({ ...state, isLoading: true }),
    [DELETE_PURCHASE_REQUEST_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_PURCHASE_REQUEST_FAILURE]: state => ({ ...state, isLoading: false }),
    [FETCH_PURCHASE_REQUEST]: startLoading,
    [FETCH_PURCHASE_REQUEST_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true,
      singlePurchaseRequestData: { ...state.singlePurchaseRequestData, isError: true }
    }),
    [FETCH_PURCHASE_REQUEST_SUCCESS]: (state, { payload }) => ({
      ...state,
      singlePurchaseRequestData: payload,
      isLoading: false,
      isError: false,
      isSuccess: true
    }),
    [FETCH_PURCHASE_REQUESTS]: startLoading,
    [FETCH_PURCHASE_REQUESTS_FAILURE]: loadingError,
    [FETCH_PURCHASE_REQUESTS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        isSuccess: true,
        hasSubmitted: false,

        errorMessage: null
      }

      newState.paginatedData.purchaseRequestsPageCount = payload.pageCount || 0
      newState.paginatedData.purchaseRequestsCount = payload.purchaseRequestsCount || 0
      newState.paginatedData.purchaseRequests = payload.purchaseRequests || []

      return newState
    },
    [LOGOUT_SUCCESS]: () => initialState,
    [INITIATE_PURCHASE_REQUEST_PAYMENT]: startSubmitting,
    [INITIATE_PURCHASE_REQUEST_PAYMENT_FAILURE]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isError: true,
      errorMessage: payload.message
    }),
    [INITIATE_PURCHASE_REQUEST_PAYMENT_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        purchaseRequestObject: payload.data,
        isSuccess: true
      }
    },
    [UPDATE_PURCHASE_REQUEST]: startSubmitting,
    [UPDATE_PURCHASE_REQUEST_FAILURE]: loadingError,
    [UPDATE_PURCHASE_REQUEST_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    }
  },
  initialState
)
